import {
  apiGet,
  apiPost,
  apiPut,
  apiDelete,
  apiPutRequest,
  apiDeleteRequest,
} from 'helpers/ApiHelper';
import Auth from 'j-toker';
import { Archived, Draft } from './constants';

export function getAssociations() {
  return apiGet('/landlords/associations');
}

export function getPackages() {
  return apiGet('/landlords/application_packages/packages');
}
export function getArchivedPackages() {
  return apiGet(`/landlords/application_packages/packages?application_status=${Archived}`);
}

export function getPackage(packageId) {
  return apiGet(`/landlords/application_packages/packages/${packageId}`);
}

export function deletePackage(packageId) {
  return apiDeleteRequest(`/landlords/application_packages/packages/${packageId}`);
}

export function createPackage(data) {
  return apiPost('/landlords/application_packages/packages', data);
}

export function updatePackage(packageId, data) {
  return apiPutRequest(
    `${Auth.getApiUrl()}/landlords/application_packages/packages/${packageId}`,
    data
  );
}

export function archivePackage(packageId) {
  return apiPutRequest(
    `${Auth.getApiUrl()}/landlords/application_packages/packages/${packageId}/archive`
  );
}

export const translationsToObject = (translations) => {
  return translations.reduce((acc, values) => {
    acc[values['locale']] = values;
    return acc;
  }, {});
};

const translationsToArray = (data) => {
  const translations = data.selected_languages.map((lang) => data.translations[lang]);
  return { ...data, translations };
};

export const translationsObjectToArray = (translations) => {
  const entries = Object.entries(translations);
  return entries.map((translation) => translation[1]);
};

export function getTemplates() {
  return apiGet('/landlords/application_templates/templates');
}

export function getArchivedTemplates() {
  return apiGet(`/landlords/application_templates/templates?application_status=${Archived}`);
}

export function getTemplate(templateId) {
  return apiGet(`/landlords/application_templates/templates/${templateId}`);
}

export function getTemplateForPreview(templateId) {
  return apiGet(`/landlords/application_templates/templates/${templateId}/preview`);
}

export function createTemplate(data) {
  const formattedData = translationsToArray(data);
  return apiPost(`/landlords/application_templates/templates`, {
    application_template: formattedData,
  });
}

export function updateTemplate(templateId, data) {
  const formattedData = translationsToArray(data);

  return apiPut(Auth.getApiUrl() + `/landlords/application_templates/templates/${templateId}`, {
    application_template: formattedData,
  });
}

export function archiveTemplate(templateId) {
  return apiPut(Auth.getApiUrl() + `/landlords/application_templates/templates/${templateId}`, {
    application_template: { status: Archived },
  });
}

export function restoreTemplate(templateId) {
  return apiPut(Auth.getApiUrl() + `/landlords/application_templates/templates/${templateId}`, {
    application_template: { status: Draft },
  });
}

export function deleteTemplate(templateId) {
  return apiDelete(Auth.getApiUrl() + `/landlords/application_templates/templates/${templateId}`);
}

export function getTemplateBlockLibrary() {
  return apiGet('/landlords/application_templates/blocks');
}

export function createTemplateStep(templateId, data) {
  const formattedTranslations = translationsObjectToArray(data.translations);
  return apiPost(`/landlords/application_templates/templates/${templateId}/steps`, {
    step: { ...data, translations: formattedTranslations },
  });
}

export function getTemplateStep(templateId, stepId) {
  return apiGet(`/landlords/application_templates/templates/${templateId}/steps/${stepId}`);
}

export function updateTemplateStep(templateId, stepId, data) {
  const formattedTranslations = translationsObjectToArray(data.translations);
  return apiPutRequest(`/landlords/application_templates/templates/${templateId}/steps/${stepId}`, {
    step: { ...data, translations: formattedTranslations },
  });
}

export function createTemplateStepBlocks(templateId, stepId, data) {
  const formattedData = data.map((block) => {
    const formattedFields = block.fields.map((field) => ({
      ...field,
      translations: translationsObjectToArray(field.translations),
    }));
    return {
      ...block,
      fields: formattedFields,
      translations: translationsObjectToArray(block.translations),
    };
  });

  return apiPost(
    `/landlords/application_templates/templates/${templateId}/steps/${stepId}/blocks`,
    { blocks: formattedData }
  );
}
